/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * バッチ処理対象
 * 
 * @export
 * @interface ListTargets200ResponseItemsInner
 */
export interface ListTargets200ResponseItemsInner {
    /**
     * 実施日
     * @type {Date}
     * @memberof ListTargets200ResponseItemsInner
     */
    issueDate: Date;
    /**
     * 対象サービス（service_category）
     * @type {number}
     * @memberof ListTargets200ResponseItemsInner
     */
    serviceCategory: ListTargets200ResponseItemsInnerServiceCategoryEnum | null;
    /**
     * 集計対象期間（開始日）
     * @type {Date}
     * @memberof ListTargets200ResponseItemsInner
     */
    startDate: Date;
    /**
     * 集計対象期間（終了日）
     * @type {Date}
     * @memberof ListTargets200ResponseItemsInner
     */
    endDate: Date;
    /**
     * operation_id（数値IDの文字列）。未作成の場合は null。
     * @type {string}
     * @memberof ListTargets200ResponseItemsInner
     */
    operationId?: string;
    /**
     * 業務処理ステータス
     * 
     * @type {number}
     * @memberof ListTargets200ResponseItemsInner
     */
    status?: ListTargets200ResponseItemsInnerStatusEnum;
    /**
     * 対象 payment_group 数（見込み）
     * @type {number}
     * @memberof ListTargets200ResponseItemsInner
     */
    expectedPaymentGroupCount?: number;
    /**
     * 対象 company 数（見込み）
     * @type {number}
     * @memberof ListTargets200ResponseItemsInner
     */
    expectedCompanyCount?: number;
}


/**
 * @export
 */
export const ListTargets200ResponseItemsInnerServiceCategoryEnum = {
    OVERSEAS_ROAMING: 0
} as const;
export type ListTargets200ResponseItemsInnerServiceCategoryEnum = typeof ListTargets200ResponseItemsInnerServiceCategoryEnum[keyof typeof ListTargets200ResponseItemsInnerServiceCategoryEnum];

/**
 * @export
 */
export const ListTargets200ResponseItemsInnerStatusEnum = {
    COMPLETED_AGGREGATED: 0,
    FAILED: 1,
    COMPLETED_PUBLISHED: 2,
    COMPLETED_DETAIL_PUBLISHED: 3,
    RUNNING: 4
} as const;
export type ListTargets200ResponseItemsInnerStatusEnum = typeof ListTargets200ResponseItemsInnerStatusEnum[keyof typeof ListTargets200ResponseItemsInnerStatusEnum];


/**
 * Check if a given object implements the ListTargets200ResponseItemsInner interface.
 */
export function instanceOfListTargets200ResponseItemsInner(value: object): value is ListTargets200ResponseItemsInner {
    if (!('issueDate' in value) || value['issueDate'] === undefined) return false;
    if (!('serviceCategory' in value) || value['serviceCategory'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    return true;
}

export function ListTargets200ResponseItemsInnerFromJSON(json: any): ListTargets200ResponseItemsInner {
    return ListTargets200ResponseItemsInnerFromJSONTyped(json, false);
}

export function ListTargets200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTargets200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'issueDate': (new Date(json['issue_date'])),
        'serviceCategory': json['service_category'],
        'startDate': (new Date(json['start_date'])),
        'endDate': (new Date(json['end_date'])),
        'operationId': json['operation_id'] == null ? undefined : json['operation_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'expectedPaymentGroupCount': json['expected_payment_group_count'] == null ? undefined : json['expected_payment_group_count'],
        'expectedCompanyCount': json['expected_company_count'] == null ? undefined : json['expected_company_count'],
    };
}

export function ListTargets200ResponseItemsInnerToJSON(json: any): ListTargets200ResponseItemsInner {
    return ListTargets200ResponseItemsInnerToJSONTyped(json, false);
}

export function ListTargets200ResponseItemsInnerToJSONTyped(value?: ListTargets200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'issue_date': ((value['issueDate']).toISOString().substring(0,10)),
        'service_category': value['serviceCategory'],
        'start_date': ((value['startDate']).toISOString().substring(0,10)),
        'end_date': ((value['endDate']).toISOString().substring(0,10)),
        'operation_id': value['operationId'],
        'status': value['status'],
        'expected_payment_group_count': value['expectedPaymentGroupCount'],
        'expected_company_count': value['expectedCompanyCount'],
    };
}

